<alaris-dialog [closeAction]="close.bind(this)"
    confirmButtonText=""
    size="md">
    <h6 slot="header">{{ 'manual_dipping.log' | translate }}</h6>
    <alaris-icon slot="header"
        class="copy"
        [alarisTooltip]="(logCopied ? 'gl.copied' : 'gl.copy') | translate"
        [name]="logCopied ? 'icon-copy-plus' : 'icon-copy'"
        (click)="copy()"></alaris-icon>
    <div slot="content">
        <alaris-text-area [readonly]="true"
            [expandable]="true"
            maxHeight="none"
            [formControl]="logControl"></alaris-text-area>
    </div>
</alaris-dialog>